<script>
  import { fade, fly } from "svelte/transition";
  import AdviceCard from "./AdviceCard.svelte";
  let { cards = [] } = $props();
  let lines = $derived(cards.length / 3);
</script>

<div
  class="wc-apl-container"
  role="group"
  aria-label="3 items at either 25% or 100% width">
  {#each cards.slice(0, 3) as card (card.linkUrl)}
    <div class="wc-apl-container__child" transition:fade|global>
      <AdviceCard {card} />
    </div>
  {/each}
</div>
{#if lines > 1}
  <div
    class="wc-apl-container"
    role="group"
    aria-label="3 items at either 25% or 100% width">
    {#each cards.slice(3, 6) as card (card.linkUrl)}
      <div class="wc-apl-container__child" transition:fade|global>
        <AdviceCard {card} />
      </div>
    {/each}
  </div>
{/if}
{#if lines > 2}
  <div
    class="wc-apl-container"
    role="group"
    aria-label="3 items at either 25% or 100% width">
    {#each cards.slice(6, 9) as card (card.linkUrl)}
      <div class="wc-apl-container__child" transition:fade|global>
        <AdviceCard {card} />
      </div>
    {/each}
  </div>
{/if}
{#if lines > 3}
  <div
    class="wc-apl-container"
    role="group"
    aria-label="3 items at either 25% or 100% width">
    {#each cards.slice(9, 12) as card (card.linkUrl)}
      <div class="wc-apl-container__child" transition:fade|global>
        <AdviceCard {card} />
      </div>
    {/each}
  </div>
{/if}
